import { useEffect } from "react";

export const SITE_ORIGIN = "https://dcyb.ai";

const setTag = (tagName, selector, attrs, valueKey, value, restores) => {
  let element = document.head.querySelector(selector);
  if (element) {
    const previous = element.getAttribute(valueKey);
    restores.push(() => element.setAttribute(valueKey, previous));
  } else {
    element = document.createElement(tagName);
    Object.entries(attrs).forEach(([key, attrValue]) => element.setAttribute(key, attrValue));
    document.head.appendChild(element);
    restores.push(() => element.remove());
  }
  element.setAttribute(valueKey, value);
};

export const usePageMeta = ({ title, description, path, image }) => {
  useEffect(() => {
    const url = `${SITE_ORIGIN}${path}`;
    const imageUrl = `${SITE_ORIGIN}${image}`;
    const previousTitle = document.title;
    const restores = [];
    document.title = title;
    setTag("link", 'link[rel="canonical"]', { rel: "canonical" }, "href", url, restores);
    [["name", "description", description], ["property", "og:type", "website"], ["property", "og:site_name", "DCYB"], ["property", "og:title", title],
      ["property", "og:description", description], ["property", "og:url", url], ["property", "og:image", imageUrl], ["name", "twitter:card", "summary_large_image"],
      ["name", "twitter:title", title], ["name", "twitter:description", description], ["name", "twitter:image", imageUrl]]
      .forEach(([attr, key, value]) => setTag("meta", `meta[${attr}="${key}"]`, { [attr]: key }, "content", value, restores));
    return () => { document.title = previousTitle; restores.reverse().forEach((restore) => restore()); };
  }, [title, description, path, image]);
};
